"use strict";

exports.__esModule = true;
exports.ResetPasswordRoutes = ResetPasswordRoutes;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _ResetPasswordScreen = require("./ResetPasswordScreen");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ResetPasswordRoutes() {
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "/reset-password",
    element: /*#__PURE__*/_react["default"].createElement(_ResetPasswordScreen.ResetPasswordScreen, null)
  }));
}